export default __webpack_public_path__ + "static/media/Snd_CJ.02e3b30e.mp3";